import './NarrationModeSection.css';
import { useNarrationMode, type NarrationMode } from '../../hooks/useNarrationMode';

/**
 * V4 Voice GM (2026-06-02) — narration verbosity picker.
 *
 * Sits inside AudioPanel below MicActivationSection. User picks 'full'
 * (default — full paragraph text auto-narrates) or 'brief' (short cue
 * only; manual ▶ Read Aloud still plays the full text).
 */

const OPTIONS: Array<{ value: NarrationMode; label: string; description: string }> = [
  {
    value: 'full',
    label: 'Full (default)',
    description: 'Auto-narrate the complete paragraph text every time.',
  },
  {
    value: 'brief',
    label: 'Brief',
    description: 'Short audio cue only (paragraph number). Click ▶ for full text.',
  },
  {
    value: 'first-visit',
    label: 'First visit only',
    description: 'Full narration on first visit; brief cue on revisits.',
  },
];

export interface NarrationModeSectionProps {
  testidPrefix?: string;
}

export function NarrationModeSection({
  testidPrefix = 'br-narration-mode',
}: NarrationModeSectionProps) {
  const [mode, setMode] = useNarrationMode();

  return (
    <section
      className="br-scenario-drawer-section br-narration-mode"
      data-testid={testidPrefix}
    >
      <h3 className="br-label">Auto-narration</h3>
      <fieldset className="br-narration-mode-fieldset">
        <legend className="sr-only">Narration verbosity</legend>
        {OPTIONS.map((opt) => (
          <label
            key={opt.value}
            className="br-narration-mode-option"
            data-testid={`${testidPrefix}-${opt.value}`}
          >
            <input
              type="radio"
              name="narration-mode"
              value={opt.value}
              checked={mode === opt.value}
              onChange={() => setMode(opt.value)}
            />
            <span className="br-narration-mode-label">{opt.label}</span>
            <span className="br-narration-mode-description br-label">
              {opt.description}
            </span>
          </label>
        ))}
      </fieldset>
    </section>
  );
}

export default NarrationModeSection;
